module.exports = __webpack_public_path__ + "static/media/emedhub.19013ded.svg";